module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jumpList.length === 1),
      expression: "jumpList.length === 1"
    }],
    staticClass: "btn btn__green",
    on: {
      "click": function($event) {
        return _vm.jumpAdd({
          options_ids: []
        })
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "kp-panel-jump"
  }), _vm._v(" " + _vm._s(_vm.$t('edit.sidebar.add_jump')))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-556c8785!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/buttons/AddFirst.vue
 ** module id = 833
 ** module chunks = 1
 **/